import { getCsrfValue } from "~/api/ApiHelper";
import type { UnitMode } from "~/feature/UnitMode/UnitMode";
import { resolveApiUrl } from "~/utils/url/urlResolver";

interface SRPPreferencesApi {
  useNewDesign: boolean;
  view: "SIMPLE" | "TECHNICAL";
  unit: UnitMode;
}

export const apiUpdateUserPreferences = (updates: Partial<SRPPreferencesApi>) => {
  const url = resolveApiUrl("/search/updatePreferences");
  const body = {
    unit: updates.unit,
    newSearchView: updates.useNewDesign,
    searchView: updates.view,
  };

  return fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    body: JSON.stringify(body),
  });
};
